import { render, staticRenderFns } from "./buttonLinkRowBlock.vue?vue&type=template&id=2e36c4a3&scoped=true&"
import script from "./buttonLinkRowBlock.vue?vue&type=script&lang=js&"
export * from "./buttonLinkRowBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36c4a3",
  null
  
)

export default component.exports